
import { createSelector } from 'reselect';

const getCustomFields = (store) => store.customFieldsStore;

export const getFilteredFields = createSelector(
    getCustomFields,
    customFields => {
        if (
            !Object.keys(customFields.customFields).length ||
            customFields.customFields.customerName && customFields.customFields.customerName.originalValue
        ) {
            return customFields;
        }

        // Use destructuring to avoid mutating stateful data
        const { customFields: { customerName, ...fields }, ...otherProperties } = customFields;

        return {
            ...otherProperties,
            customFields: fields
        };
    }
);



// WEBPACK FOOTER //
// ./src/sections/CustomFields/CustomFieldsSelectors.ts